import Vue  from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

/**
 * Экземпляр хранилища
 * @type {Store<{accountsList: null}>}
 */
const store = new Vuex.Store({
	state() {
		return {
			/**
			 * Список инвестиционных счетов
			 */
			accountsList: [],
			accountData: null,
			personalAccounts: null,
			currentPage: 1,
			totalPages: 1,
			recordsPerPage: 20,
			currentUserId: 0,
		};
	},
	mutations: {
		/**
		 * Обновление списка счетов
		 * @param state
		 * @param value
		 */
		updateAccountsList(state, value) {
			state.accountsList = value;
		},
		/**
		 * Обновление выбранного счета
		 * @param state
		 * @param value
		 */
		accountData(state, value) {
			state.accountData = value;
		},
		/**
		 * Обновление для лицевых счетов
		 * @param state
		 * @param value
		 */
		personalAccounts(state, value) {
			state.personalAccounts = value;
		},

		/**
		 * Обновление текущей страницы
		 * @param state
		 * @param value
		 */
		currentPage(state, value) {
			state.currentPage = value;
		},

		/**
		 * Обновление счетчика доступных страниц
		 * @param state
		 * @param value
		 */
		totalPages(state, value) {
			state.totalPages = value;
		},

		/**
		 * Обновление величины отображаемых на странице записей
		 * @param state
		 * @param value
		 */
		recordsPerPage(state, value) {
			state.recordsPerPage = value;
		},

		/**
		 * Обновление ID текущего пользователя
		 * @param state
		 * @param value
		 */
		currentUserId(state, value) {
			state.currentUserId = value;
		},
	},
});

export default store;